<ion-accordion-group
  expand="inset"
  [multiple]="true"
  [value]="[]"
  class="margin-top50 width100"
  [animated]="false"
>
  <ion-accordion value="first">
    <ion-item slot="header" color="light">
      <ion-label>{{
        allStaffCards.length === 0
          ? ("No staff cards in room" | translate)
          : ("Staff Cards" | translate)
      }}</ion-label>
    </ion-item>
    <div class="ion-padding" slot="content">
      <div class="flex-row">
        <input
          type="text"
          autocomplete="disabled"
          class="font-size18 to-right"
          [value]="staffCardSearchValue"
          placeholder="{{ 'Search cards' | translate }}"
          valueChangedDelay="500"
          (afterValueChanged)="
            onAfterSearchStaffCardsChange($event.target.value)
          "
        />
        <app-paginator
          class="to-right"
          [paginationData]="paginationData"
          (targetPage)="clickTargetPage($event)"
        >
        </app-paginator>
      </div>
      <table *ngIf="displayedStaffCards.length > 0">
        <tr>
          <th class="uppercase bg-white">{{ "Valid from" | translate }}</th>
          <th class="uppercase bg-white">{{ "Valid to" | translate }}</th>
          <th class="uppercase bg-white">{{ "User" | translate }}</th>
        </tr>
        <tr
          *ngFor="let card of displayedStaffCards; let i = index"
          class="br-gray-b"
          [ngClass]="{ 'inactive-card': card.validFrom | getValidFromToCss }"
        >
          <td>
            <div class="flex-row-center">
              <span>{{ card.validFrom | date : "dd.MM.yyyy." }}</span>
              <span>{{ card.validFrom | date : " - HH:mm" }}</span>
            </div>
          </td>
          <td>
            <div
              class="flex-row-center"
              [ngClass]="card.validTo | getValidToCssClass"
            >
              <span>{{ card.validTo | date : "dd.MM.yyyy." }}</span>
              <span>{{ card.validTo | date : " - HH:mm" }}</span>
            </div>
          </td>
          <td>{{ card.user.fullName }}</td>
        </tr>
      </table>
      <div class="flex-row">
        <app-paginator
          class="to-right"
          [paginationData]="paginationData"
          (targetPage)="clickTargetPage($event)"
        >
        </app-paginator>
      </div>
      <h3
        *ngIf="displayedStaffCards.length === 0"
        class="flex-row-center-h margin-top50"
      >
        {{ "No staff cards in room" | translate }}.
        <ng-container *ngIf="staffCardSearchValue !== ''">
          {{ "Filter active" | translate }}</ng-container
        >
      </h3>
    </div>
  </ion-accordion>
</ion-accordion-group>
